import { useQueryHook } from "@/hooks"
import { readPositions } from "@/app/api/position"
import { ReadPositionsResponse } from "@/types/position"
import { createAccountStore } from "@/stores/account"

// ordering: "position"(기본, 등번호 순 — 테이블 정렬 rank용) / "group"(그룹 클러스터 — 드롭다운용)
export const usePositionsQuery = (ordering: "position" | "group" = "position") => {
  // 팀 종목(sportType)을 실어 해당 종목 포지션을 조회. 팀 전환 시 queryKey가 바뀌어 재조회.
  const sportType = createAccountStore((state) => state.teamProfileInfo?.sportType)

  return useQueryHook<ReadPositionsResponse, unknown>({
    queryKey: ["readPositions", sportType, ordering],
    queryFn: () => readPositions(2, sportType, ordering),
  })
}
